import axios from 'axios';

// Backend URL - environment variable'dan al
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

const API = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Cities
export const getCities = () => API.get('/cities');
export const detectVisitorCity = () => API.get('/geo/detect-city');
export const getCitiesWithVenues = (premiumOnly = false) => API.get(`/cities-with-venues?premium_only=${premiumOnly}`);
export const getDistrictsWithVenues = (cityId, premiumOnly = false) => API.get(`/districts-with-venues?cityId=${cityId}&premium_only=${premiumOnly}`);

// Blog APIs
export const getBlogs = (limit) => API.get('/blogs', { params: limit ? { limit } : {} });
export const getBlogBySlug = (slug) => API.get(`/blogs/${slug}`);
export const createBlog = (data) => API.post('/admin/blogs', data, {
  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
});
export const getAllBlogsAdmin = () => API.get('/admin/blogs', {
  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
});
export const deleteBlog = (id) => API.delete(`/admin/blogs/${id}`, {
  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
});
export const updateBlog = (id, data) => API.put(`/admin/blogs/${id}`, data, {
  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
});

// Districts
export const getDistricts = (cityId) => API.get('/districts', { params: { cityId } });

// Venues
export const getVenues = (params) => API.get('/venues', { params });

export const getFeaturedVenues = () => API.get('/venues/featured');

export const getVenue = (id) => API.get(`/venues/${id}`);

// Reservations
export const createReservation = (data) => API.post('/reservations', data);

// Venue Owner APIs
export const getMyVenues = (token) => API.get('/my-venues', {
  headers: { Authorization: `Bearer ${token}` }
});

export const getMyReservations = (token) => API.get('/my-reservations', {
  headers: { Authorization: `Bearer ${token}` }
});

export const getMyStats = (token) => API.get('/my-stats', {
  headers: { Authorization: `Bearer ${token}` }
});

// Public platform statistics
export const getPlatformStats = () => API.get('/stats/platform');

export const updateMyReservationStatus = (reservationId, status, token) => API.put(
  `/my-reservations/${reservationId}/status?status=${status}`,
  {},
  { headers: { Authorization: `Bearer ${token}` } }
);

export const updateMyVenue = (venueId, venueData, token) => API.put(
  `/my-venues/${venueId}`,
  venueData,
  { headers: { Authorization: `Bearer ${token}` } }
);

export const updateVenueSettings = (venueId, settings, token) => API.put(
  `/my-venues/${venueId}/settings`,
  settings,
  { headers: { Authorization: `Bearer ${token}` } }
);

export const trackVenueView = (venueId) => API.post(`/venues/${venueId}/view`);
export const trackVenueInquiry = (venueId) => API.post(`/venues/${venueId}/inquiry`);
export const trackPhoneClick = (venueId) => API.post(`/venues/${venueId}/phone-click`);
export const trackWhatsAppClick = (venueId, message = '', actionType = 'general') => API.post(`/venues/${venueId}/whatsapp-click`, { message, actionType });

// Admin APIs
export const adminGetStats = (token) => API.get('/admin/stats', {
  headers: { Authorization: `Bearer ${token}` }
});

export const adminGetVenues = (token) => API.get('/admin/venues', {
  headers: { Authorization: `Bearer ${token}` }
});

export const adminGetOwners = (token) => API.get('/admin/venue-owners', {
  headers: { Authorization: `Bearer ${token}` }
});

export const adminGetPendingChanges = (token) => API.get('/admin/pending-changes', {
  headers: { Authorization: `Bearer ${token}` }
});

export const adminGetReservations = (token) => API.get('/admin/reservations', {
  headers: { Authorization: `Bearer ${token}` }
});

export const adminApproveVenue = (venueId, token) => API.put(`/admin/venues/${venueId}/approve`, {}, {
  headers: { Authorization: `Bearer ${token}` }
});

export const adminRejectVenue = (venueId, token) => API.put(`/admin/venues/${venueId}/reject`, {}, {
  headers: { Authorization: `Bearer ${token}` }
});

export const adminToggleFeatured = (venueId, token) => API.put(`/admin/venues/${venueId}/featured`, {}, {
  headers: { Authorization: `Bearer ${token}` }
});

export const adminApproveOwner = (ownerId, token) => API.put(`/admin/venue-owners/${ownerId}/approve`, {}, {
  headers: { Authorization: `Bearer ${token}` }
});

export const adminDeleteOwner = (ownerId, token) => API.delete(`/admin/venue-owners/${ownerId}`, {
  headers: { Authorization: `Bearer ${token}` }
});

export const adminClaimVenue = (data, token) => API.post('/admin/claim-venue', data, {
  headers: { Authorization: `Bearer ${token}` }
});


export const adminGetVenueUpdates = (days, token) => API.get(`/admin/venue-updates?days=${days}`, {
  headers: { Authorization: `Bearer ${token}` }
});

export const adminGetVenueUpdateHistory = (venueId, token) => API.get(`/admin/venue-updates/${venueId}`, {
  headers: { Authorization: `Bearer ${token}` }
});


export const adminApproveChange = (changeId, token) => API.put(`/admin/pending-changes/${changeId}/approve`, {}, {
  headers: { Authorization: `Bearer ${token}` }
});

export const adminRejectChange = (changeId, token) => API.put(`/admin/pending-changes/${changeId}/reject`, {}, {
  headers: { Authorization: `Bearer ${token}` }
});

// Admin: Lead Management
export const getDistrictLeads = (token) => API.get('/admin/district-leads', {
  headers: { Authorization: `Bearer ${token}` }
});

export const getCityLeads = (token) => API.get('/admin/city-leads', {
  headers: { Authorization: `Bearer ${token}` }
});

export const updateDistrictLeadStatus = (leadId, status, notes, token) => API.put(`/admin/district-leads/${leadId}`, 
  { status, notes }, 
  { headers: { Authorization: `Bearer ${token}` } }
);

export const updateCityLeadStatus = (leadId, status, notes, token) => API.put(`/admin/city-leads/${leadId}`, 
  { status, notes }, 
  { headers: { Authorization: `Bearer ${token}` } }
);

export const adminUpdateReservationStatus = (reservationId, status, token) => API.put(
  `/admin/reservations/${reservationId}/status?status=${status}`, 
  {}, 
  { headers: { Authorization: `Bearer ${token}` } }
);

// Settings APIs
export const getSettings = () => API.get('/settings');

export const updateSettings = (settings, token) => API.put('/admin/settings', settings, {
  headers: { Authorization: `Bearer ${token}` }
});

// Testimonials APIs
export const getTestimonials = () => API.get('/testimonials');

export const adminGetTestimonials = (token) => API.get('/admin/testimonials', {
  headers: { Authorization: `Bearer ${token}` }
});

export const createTestimonial = (testimonial, token) => API.post('/admin/testimonials', testimonial, {
  headers: { Authorization: `Bearer ${token}` }
});

// Admin - Customer Management
export const getAllCustomersAdmin = () => API.get('/admin/customers');
export const deleteCustomerAdmin = (customerId) => API.delete(`/admin/customers/${customerId}`);

// Venue Owner - Inquiries
export const getVenueOwnerInquiries = () => API.get('/venue-owner/inquiries');
export const respondToInquiry = (inquiryId, response) => API.put(`/venue-owner/inquiries/${inquiryId}/respond`, response);

export const updateTestimonial = (testimonialId, testimonial, token) => API.put(`/admin/testimonials/${testimonialId}`, testimonial, {
  headers: { Authorization: `Bearer ${token}` }
});

export const deleteTestimonial = (testimonialId, token) => API.delete(`/admin/testimonials/${testimonialId}`, {
  headers: { Authorization: `Bearer ${token}` }
});

// Venue Owner Reservation Management APIs
export const createVenueReservation = (venueId, reservationData, token) => API.post(
  `/my-venues/${venueId}/reservations`,
  reservationData,
  { headers: { Authorization: `Bearer ${token}` } }
);

export const updateVenueReservation = (reservationId, reservationData, token) => API.put(
  `/my-venues/reservations/${reservationId}`,
  reservationData,
  { headers: { Authorization: `Bearer ${token}` } }
);

export const deleteVenueReservation = (reservationId, token) => API.delete(
  `/my-venues/reservations/${reservationId}`,
  { headers: { Authorization: `Bearer ${token}` } }
);

export const downloadReservationContract = (reservationId, token) => {
  return axios.get(`${BACKEND_URL}/api/my-venues/reservations/${reservationId}/contract-pdf`, {
    headers: { Authorization: `Bearer ${token}` },
    responseType: 'blob'
  });
};

// Contact Messages
export const createContactMessage = (messageData) => API.post('/contact', messageData);

export const getAllContactMessages = (token, page = 1, limit = 30) => API.get('/admin/contact-messages', {
  params: { page, limit },
  headers: { Authorization: `Bearer ${token}` }
});

export const updateContactMessage = (messageId, status, adminNotes, token) => API.put(
  `/admin/contact-messages/${messageId}`,
  null,
  {
    params: { status, admin_notes: adminNotes },
    headers: { Authorization: `Bearer ${token}` }
  }
);

export const deleteContactMessage = (messageId, token) => API.delete(
  `/admin/contact-messages/${messageId}`,
  { headers: { Authorization: `Bearer ${token}` } }
);


// Quote Requests
export const createQuoteRequest = (quoteData) => API.post('/quote-requests', quoteData);

export const getMyQuoteRequests = (token) => API.get('/my-venues/quote-requests', {
  headers: { Authorization: `Bearer ${token}` }
});

export const updateQuoteRequestStatus = (requestId, status, token) => API.put(
  `/my-venues/quote-requests/${requestId}/status`,
  null,
  {
    params: { status },
    headers: { Authorization: `Bearer ${token}` }
  }
);

// Mark quote request as viewed (cancels scheduled SMS)
export const markQuoteRequestViewed = (requestId, token) => API.put(
  `/my-venues/quote-requests/${requestId}/view`,
  null,
  {
    headers: { Authorization: `Bearer ${token}` }
  }
);


// ============================================
// VENUE VISIT (RANDEVU) APIs
// ============================================

// Get venue visit availability (public)
export const getVenueAvailability = (venueId) => API.get(`/venues/${venueId}/availability`);

// Update venue visit settings (venue owner)
export const updateVenueVisitSettings = (venueId, settings, token) => API.put(
  `/my-venues/${venueId}/visit-settings`,
  settings,
  { headers: { Authorization: `Bearer ${token}` } }
);

// Get venue owner's visit requests
export const getMyVenueVisits = (token) => API.get('/my-venues/visits', {
  headers: { Authorization: `Bearer ${token}` }
});

// Approve venue visit
export const approveVenueVisit = (visitId, token) => API.put(
  `/my-venues/visits/${visitId}/approve`,
  {},
  { headers: { Authorization: `Bearer ${token}` } }
);

// Reject venue visit with reason
export const rejectVenueVisit = (visitId, reason, token) => API.put(
  `/my-venues/visits/${visitId}/reject`,
  { reason },
  { headers: { Authorization: `Bearer ${token}` } }
);


// Bulk Quote Requests
export const createBulkQuoteRequest = (bulkQuoteData) => API.post('/bulk-quote-requests', bulkQuoteData);

export const getBulkQuoteRequests = (token, page = 1, limit = 30) => API.get('/admin/bulk-quote-requests', {
  params: { page, limit },
  headers: { Authorization: `Bearer ${token}` }
});

export const updateBulkQuoteRequestStatus = (requestId, status, token) => API.put(
  `/admin/bulk-quote-requests/${requestId}/status`,
  null,
  {
    params: { status },
    headers: { Authorization: `Bearer ${token}` }
  }
);

// Unclaimed Venue Quote Requests (WhatsApp)
export const createUnclaimedQuoteRequest = (quoteData) => API.post('/unclaimed-quote-requests', quoteData);

export const getUnclaimedQuoteRequests = (token, page = 1, limit = 30) => API.get('/admin/unclaimed-quote-requests', {
  params: { page, limit },
  headers: { Authorization: `Bearer ${token}` }
});

export const getAllQuoteRequests = (token, page = 1, limit = 30) => API.get('/admin/all-quote-requests', {
  params: { page, limit },
  headers: { Authorization: `Bearer ${token}` }
});

export const getUnclaimedVenueStats = (token) => API.get('/admin/unclaimed-venue-stats', {
  headers: { Authorization: `Bearer ${token}` }
});

// Unclaimed Phone Calls
export const trackUnclaimedPhoneCall = (callData) => API.post('/unclaimed-phone-call', callData);

export const getUnclaimedPhoneCalls = (token, page = 1, limit = 30) => API.get('/admin/unclaimed-phone-calls', {
  params: { page, limit },
  headers: { Authorization: `Bearer ${token}` }
});

// Unclaimed WhatsApp Clicks
export const trackUnclaimedWhatsAppClick = (clickData) => API.post('/unclaimed-whatsapp-click', clickData);

export const getUnclaimedWhatsAppClicks = (token, page = 1, limit = 30) => API.get('/admin/unclaimed-whatsapp-clicks', {
  params: { page, limit },
  headers: { Authorization: `Bearer ${token}` }
});

// WhatsApp Channel Clicks
export const trackWhatsAppChannelClick = (clickData) => API.post('/whatsapp-channel-click', clickData);

export const getWhatsAppChannelClicks = (token, page = 1, limit = 30) => API.get('/admin/whatsapp-channel-clicks', {
  params: { page, limit },
  headers: { Authorization: `Bearer ${token}` }
});


// Venue Applications (Sizi Arayalım)
export const createVenueApplication = (applicationData) => API.post('/venue-applications', applicationData);

export const getVenueApplications = (token) => API.get('/admin/venue-applications', {
  headers: { Authorization: `Bearer ${token}` }
});

export const updateVenueApplicationStatus = (applicationId, status, token) => API.put(
  `/admin/venue-applications/${applicationId}/status`,
  null,
  {
    params: { status },
    headers: { Authorization: `Bearer ${token}` }
  }
);

export const deleteVenueApplication = (applicationId, token) => API.delete(
  `/admin/venue-applications/${applicationId}`,
  {
    headers: { Authorization: `Bearer ${token}` }
  }
);


// File Upload APIs
export const uploadVenueImage = async (file, token) => {
  const formData = new FormData();
  formData.append('file', file);
  
  return API.post('/upload/venue-image', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `Bearer ${token}`
    }
  });
};

export const deleteVenueImage = (imageUrl, token) => API.delete('/upload/venue-image', {
  params: { image_url: imageUrl },
  headers: { Authorization: `Bearer ${token}` }
});

// Membership Plans APIs
export const getMembershipPlans = () => API.get('/membership-plans');

export const getAdminMembershipPlans = (token) => API.get('/admin/membership-plans', {
  headers: { Authorization: `Bearer ${token}` }
});

export const createMembershipPlan = (planData, token) => API.post('/admin/membership-plans', planData, {
  headers: { Authorization: `Bearer ${token}` }
});

export const updateMembershipPlan = (planId, planData, token) => API.put(`/admin/membership-plans/${planId}`, planData, {
  headers: { Authorization: `Bearer ${token}` }
});

export const deleteMembershipPlan = (planId, token) => API.delete(`/admin/membership-plans/${planId}`, {
  headers: { Authorization: `Bearer ${token}` }
});

export const updateVenuePlan = (venueId, planName, planEndDate, token) => API.put(`/admin/venues/${venueId}/plan`, null, {
  params: { 
    plan_name: planName,
    plan_end_date: planEndDate
  },
  headers: { Authorization: `Bearer ${token}` }
});

// Password Change
export const changePassword = (currentPassword, newPassword) => API.post('/auth/change-password', {
  currentPassword,
  newPassword
}, {
  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
});



// ============================================
// VENUE QUESTIONS & ANSWERS APIs
// ============================================

// Get all answered questions for a venue (PUBLIC)
export const getVenueQuestions = (venueId) => API.get(`/venues/${venueId}/questions`);

// Create a new question for a venue (PUBLIC)
export const createVenueQuestion = (venueId, questionData) => 
  API.post(`/venues/${venueId}/questions`, questionData);

// Get all questions for venue owner (OWNER ONLY)
export const getOwnerQuestions = () => API.get('/venue-owner/questions', {
  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
});

// Answer a question (OWNER ONLY)
export const answerVenueQuestion = (questionId, answer) => 
  API.put(`/venue-owner/questions/${questionId}/answer`, { answer }, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  });

// Report a question (OWNER ONLY)
export const reportVenueQuestion = (questionId, reason) => 
  API.post(`/venue-owner/questions/${questionId}/report`, { reason }, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  });

// Get all questions - Admin (GOD ADMIN ONLY)
export const getAllQuestionsAdmin = () => API.get('/admin/questions', {
  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
});

// Delete a question - Admin (GOD ADMIN ONLY)
export const deleteQuestionAdmin = (questionId) => 
  API.delete(`/admin/questions/${questionId}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  });


// ============================================
// VENUE STATISTICS APIs (GOD ADMIN)
// ============================================

// Get venue statistics (GOD ADMIN ONLY)
export const getVenueStats = () => API.get('/admin/venue-stats', {
  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
});

// Get venue interaction statistics - phone, whatsapp, no data venues
export const getVenueInteractionStats = () => API.get('/admin/venue-interaction-stats', {
  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
});

// Get daily stats (son 15 gün)
export const getDailyStats = (venueId = null, days = 15) => {
  const params = new URLSearchParams();
  if (venueId) params.append('venue_id', venueId);
  params.append('days', days);
  return API.get(`/admin/daily-stats?${params.toString()}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  });
};

// Get weekly stats (son 4 hafta)
export const getWeeklyStats = (venueId = null, weeks = 4) => {
  const params = new URLSearchParams();
  if (venueId) params.append('venue_id', venueId);
  params.append('weeks', weeks);
  return API.get(`/admin/weekly-stats?${params.toString()}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
  });
};

// Cleanup old stats (15 günden eski)
export const cleanupOldStats = () => API.post('/admin/cleanup-old-stats', {}, {
  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
});

// Reset daily views (GOD ADMIN ONLY)
export const resetDailyViews = () => API.post('/admin/reset-daily-views', {}, {
  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
});

// FAQ APIs
export const getVenueFAQs = (venueId, token) => API.get(`/my-venues/${venueId}/faqs`, {
  headers: { Authorization: `Bearer ${token}` }
});

export const createVenueFAQ = (venueId, faqData, token) => API.post(`/my-venues/${venueId}/faqs`, faqData, {
  headers: { Authorization: `Bearer ${token}` }
});

export const updateVenueFAQ = (venueId, faqId, faqData, token) => API.put(`/my-venues/${venueId}/faqs/${faqId}`, faqData, {
  headers: { Authorization: `Bearer ${token}` }
});

export const deleteVenueFAQ = (venueId, faqId, token) => API.delete(`/my-venues/${venueId}/faqs/${faqId}`, {
  headers: { Authorization: `Bearer ${token}` }
});

// Smart Search API
export const smartSearch = (query) => API.get(`/search/smart?q=${encodeURIComponent(query)}`);

// Reservation Calendar & Analytics APIs
export const getReservationCalendar = (venueId, startDate, endDate, token) => 
  API.get(`/my-venues/${venueId}/reservation-calendar`, {
    params: { start_date: startDate, end_date: endDate },
    headers: { Authorization: `Bearer ${token}` }
  });

export const getReservationStats = (venueId, month, token) => 
  API.get(`/my-venues/${venueId}/reservation-stats`, {
    params: { month },
    headers: { Authorization: `Bearer ${token}` }
  });

export const getRevenueTrend = (venueId, months, token) => 
  API.get(`/my-venues/${venueId}/revenue-trend`, {
    params: { months },
    headers: { Authorization: `Bearer ${token}` }
  });

export const getEventDistribution = (venueId, months, token) => 
  API.get(`/my-venues/${venueId}/event-distribution`, {
    params: { months },
    headers: { Authorization: `Bearer ${token}` }
  });

// Admin Plan Management APIs
export const getPlanExpirationReport = (days, token) =>
  API.get('/admin/plan-expiration-report', {
    params: { days },
    headers: { Authorization: `Bearer ${token}` }
  });

export const adminChangeVenuePlan = (venueId, newPlan, durationDays, token) =>
  API.post(`/admin/venues/${venueId}/change-plan`, null, {
    params: { new_plan: newPlan, duration_days: durationDays },
    headers: { Authorization: `Bearer ${token}` }
  });

// Finance/Expense Management APIs
export const createExpense = (venueId, expenseData, token) =>
  API.post(`/my-venues/${venueId}/expenses`, expenseData, {
    headers: { Authorization: `Bearer ${token}` }
  });

export const getExpenses = (venueId, startDate, endDate, token) => {
  const params = {};
  if (startDate) params.start_date = startDate;
  if (endDate) params.end_date = endDate;
  return API.get(`/my-venues/${venueId}/expenses`, {
    params,
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const updateExpense = (venueId, expenseId, expenseData, token) =>
  API.put(`/my-venues/${venueId}/expenses/${expenseId}`, expenseData, {
    headers: { Authorization: `Bearer ${token}` }
  });

export const deleteExpense = (venueId, expenseId, token) =>
  API.delete(`/my-venues/${venueId}/expenses/${expenseId}`, {
    headers: { Authorization: `Bearer ${token}` }
  });

export const createManualIncome = (venueId, incomeData, token) =>
  API.post(`/my-venues/${venueId}/incomes`, incomeData, {
    headers: { Authorization: `Bearer ${token}` }
  });

export const getFinanceSummary = (venueId, startDate, endDate, token) => {
  const params = {};
  if (startDate) params.start_date = startDate;
  if (endDate) params.end_date = endDate;
  return API.get(`/my-venues/${venueId}/finance-summary`, {
    params,
    headers: { Authorization: `Bearer ${token}` }
  });
};

// Support Ticket APIs
export const createSupportTicket = (ticketData, token) => 
  API.post('/dashboard/tickets', ticketData, {
    headers: { Authorization: `Bearer ${token}` }
  });

export const getMyTickets = (token, status = null) => {
  const params = status ? { status } : {};
  return API.get('/dashboard/tickets', {
    params,
    headers: { Authorization: `Bearer ${token}` }
  });
};

export const getTicketDetail = (ticketId, token) => 
  API.get(`/dashboard/tickets/${ticketId}`, {
    headers: { Authorization: `Bearer ${token}` }
  });

export const addTicketMessage = (ticketId, content, token) => 
  API.post(`/dashboard/tickets/${ticketId}/messages`, { content }, {
    headers: { Authorization: `Bearer ${token}` }
  });


export default API;
